import * as React from "react";
import StudentList from "./StudentList";
import StatisticSection from "./StatisticSection";
import {useEffect, useState} from "react";

const FilterLayerDaily = ({ filterInfoList, activeFilter, setActiveFilter}) => {


    // filterInfoList 데이터를 기반으로 재구성
    const transformFilterInfoList = (filterInfoList, filterTypeGroups) => {
        return filterTypeGroups.map((group) => {
         //   console.log(filterTypeGroups);
            const filter = filterInfoList.find((item) => item.filterType === group.filterType);
            return {
                icon: group.icon, // 기존 아이콘 유지
                count: filter?.studentList?.length || 0, // studentList의 길이를 count로 설정
                label: filter?.filterTitle || "Unknown", // filterTitle을 label로 설정
                active: filterTypeGroups[0]?.filterType === filter?.filterType, // 첫 번째 항목은 기본 활성화
                activeColor: group?.activeColor || "gray", // 색상 기본값 설정
                filterType: filter?.filterType || null,
                studentList: filter?.studentList || null,
                onColor: group?.onColor || null,
                description: group?.description || null,
            };
        });
    };

// 각 그룹에 대한 필터 유형과 아이콘 매핑 정의
    const keywordAnalysisGroup = [
        { filterType: "VIEW_ALL", icon: "/images/icon-users.svg", onColor: "#7394ff"},
        { filterType: "EXCELLENT_LEARNING", icon: "/images/icon-school.svg", onColor: "#5ed3a3", description:"성취도 우수, 정확도 우수"},
        { filterType: "NEEDS_GUIDANCE", icon: "/images/icon-exclamation-circle.svg", onColor: "#fc5955", description:"정확도 미흡, 속도 미달, 찍기 의심"},
    ];

    const learningProgressGroup = [
        { filterType: "INCOMPLETE", icon: "/images/icon-dashed-check.svg" , onColor: "#fc5955"},
        { filterType: "COMPLETE_FIRST", icon: "/images/icon-hexagon-number-1_gray.svg" , onColor: "#5ed3a3"},
        { filterType: "COMPLETE_SECOND", icon: "/images/icon-hexagon-number-2_gray.svg" , onColor: "#5ed3a3"},
        { filterType: "COMPLETE_ALL", icon: "/images/icon-hexagon-number-3_gray.svg" , onColor: "#5ed3a3"},
    ];

    const learningAchievementGroup = [
        { filterType: "HIGH_ACHIEVEMENT", icon: "/images/icon-award.svg", onColor: "#5ed3a3", description:"정확도 90%이상 & 속도 상위 20%"},
        { filterType: "HIGH_ACCURACY", icon: "/images/icon-target-arrow.svg" , onColor: "#5ed3a3", description: "정확도 90%이상"},
        { filterType: "LOW_ACCURACY", icon: "/images/icon-target-arrow-not.svg" , onColor: "#fc5955", description: "정확도 70% 미만"},
        { filterType: "LOW_SPEED", icon: "/images/icon-speed-not.svg" , onColor: "#fc5955", description:"속도 하위 20%"},
    ];

    const aiAnalysisGroup = [
        { filterType: "GRADE_IMPROVED", icon: "/images/icon-up.svg", onColor: "#5ed3a3", description:"다회차 완료시, 이전회차보다 정확도가 같거자 좋아지면서 속도가 빨라졌을때"},
        { filterType: "GRADE_DECLINED", icon: "/images/icon-down.svg" , onColor: "#fc5955", description: "다회차 완료시, 이전회차보다 정확도가 떨어지거나 속도가 10% 나빠졌을때"},
        { filterType: "GUESSING_SUSPECTED", icon: "/images/icon-hexagon-none.svg" , onColor: "#fc5955", description:"속도가 빠르면서, 정확도가 50%미만"},
    ];

    // 데이터를 변환하여 새로운 구조로 생성
    const keywordAnalysisData = transformFilterInfoList(filterInfoList, keywordAnalysisGroup);
    const learningProgressData = transformFilterInfoList(filterInfoList, learningProgressGroup);
    const learningAchievementData = transformFilterInfoList(filterInfoList, learningAchievementGroup);
    const aiAnalysisData = transformFilterInfoList(filterInfoList, aiAnalysisGroup);

    // 현재 활성화된 필터의 studentList 가져오기
    const activeStudentList =
        filterInfoList.find((filter) => filter.filterType === activeFilter)?.studentList || [];

    useEffect(() => {
        if(activeFilter==null){
            setActiveFilter("VIEW_ALL", activeStudentList);
        }
    },[activeFilter])

    return (
        <div className="px-6 pt-7 pb-7 mt-8 max-w-full bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] w-[1044px] max-md:px-5">
            <div className="flex gap-3 max-md:flex-col">
                {/* 왼쪽 필터 섹션 */}
                <div className="flex flex-col w-[68%] max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col items-start w-full max-md:mt-10 max-md:max-w-full">
                        <StatisticSection
                            title="키워드 분석"
                            buttons={keywordAnalysisData} // 예제 데이터로 키워드 분석 분리
                            wrapperClass="flex flex-wrap gap-2.5 items-end max-w-full rounded-3xl max-w-[650px]"
                            setActiveFilter={setActiveFilter}
                            activeFilter={activeFilter}
                        />

                        <StatisticSection
                            title="학습 진행"
                            buttons={learningProgressData} // 학습 진행 데이터
                            wrapperClass="flex gap-2.5 mt-3 max-w-full rounded-3xl max-w-[650px]"
                            setActiveFilter={setActiveFilter}
                            activeFilter={activeFilter}
                        />
                        <StatisticSection
                            title="학습 성취도"
                            buttons={learningAchievementData} // AI 분석 데이터
                            wrapperClass="flex flex-wrap gap-2.5 items-end self-stretch mt-3 w-max rounded-none max-w-[650px] max-md:max-w-full"
                            setActiveFilter={setActiveFilter}
                            activeFilter={activeFilter}
                        />

                        <StatisticSection
                            title="AI 분석"
                            buttons={aiAnalysisData} // AI 분석 데이터
                            wrapperClass="flex flex-wrap gap-2.5 items-end self-stretch mt-3 w-max rounded-none max-w-[650px] max-md:max-w-full"
                            setActiveFilter={setActiveFilter}
                            activeFilter={activeFilter}
                        />
                    </div>
                </div>

                {/* 오른쪽 학생 리스트 섹션 */}
                <StudentList studentList={activeStudentList}  activeFilter={activeFilter}/>
            </div>
        </div>
    );
};

export default FilterLayerDaily;